import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    forwardRef,
    OnInit,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import Debug from 'debug';
import { AumFormField } from './../aumFormField/aum-form-field';

const debug = Debug('aumico:aumico-lib-core-fe:AumDateInput');

/**
 * to overwrite the with you have to change the css of .mat-form-field-infix
 */
@Component({
    selector: 'aum-date-input',
    styleUrls: ['./aum-dateinput.scss'],
    templateUrl: './aum-dateinput.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AumDateInput),
            multi: true,
        },
    ],
})
export class AumDateInput extends AumFormField implements AfterViewInit, OnInit {
    @ViewChild('input', { static: true }) el: ElementRef;

    constructor(
        el: ElementRef,
        changeDetectorRef: ChangeDetectorRef,
        renderer: Renderer2,
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
    ) {
        super(el, changeDetectorRef, renderer, matIconRegistry, domSanitizer);
        this.addSvgIcon('aumico-pattern-icon-calendar');
    }
    ngOnInit(): void {}
    ngAfterViewInit() {
        const randomString = Math.random().toString(36).slice(-6);
        this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
        this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', randomString);
    }
}
